import { validateUrl as vpcValidateUrl } from "@webmonitoring/vp-common/Utils/StringValidators";

export const validateUrl: typeof vpcValidateUrl = (url, options) => {
  const urlReasonAllowList = ["malformedURL", "nonStandardProtocol", "urlTooLong"];

  return vpcValidateUrl(url, options).filter((reason) => {
    return urlReasonAllowList.includes(reason);
  });
};
